<div class="main-report-div">
  <div class="row content-div justify-content-center">
    <!-- In-place progress UI driven by SignalR stage messages from the backend.
         Replaced by the actual report once reportData arrives. -->
    <piqet-angular-report-progress
      *ngIf="!reportData"
      [message]="progressMessage"
    ></piqet-angular-report-progress>

    <!-- full report -->

    <ng-container *ngIf="reportData">
      <div class="mainClassBreadCrumb">
        <piqet-angular-breadcrumbs
          [activatedPath]="activatedRoute"
          [projectId]="projectId"
          [reportype]="reportData?.reportFormatId"
          [projectName]="reportData?.projectName || reportData.common.projectName"
          [projectNameIso]="projectType"
        ></piqet-angular-breadcrumbs>
      </div>
      <div class="mainClassExport">
        <button class="modelBTN" (click)="pdfExport(false)">Export</button>
        <div class="dropdown">
          <button class="modelBTN arrow-label">
            <i class="fa fa-angle-down chevron-i arrow-font" aria-hidden="true"></i>
          </button>
          <div class="dropdown-content">
            <button (click)="pdfExport(false)">Export</button>
            <button (click)="openShareModal()">Share</button>
          </div>
        </div>
      </div>
      <div #pdfExportData *ngIf="reportData.reportFormatId == 3">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '300px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-full-detail-report
            [reportData]="reportData"
            (checkContent)="exportPDF($event)"
          ></piqet-angular-full-detail-report>
          <ng-template kendoPDFTemplate let-pageNum="pageNum">
            <div class="page-template">
              <div class="footer">
                <div class="pdfPagePosition">{{ pageNum }}</div>
              </div>
            </div>
          </ng-template>
        </kendo-pdf-export>
      </div>

      <div #pdfExportData *ngIf="reportData.reportFormatId == 11">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '300px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-iso-report [reportData]="reportData"></piqet-angular-iso-report>
          <ng-template kendoPDFTemplate let-pageNum="pageNum">
            <div class="page-template">
              <div class="footer">
                <div class="pdfPagePosition">{{ pageNum }}</div>
              </div>
            </div>
          </ng-template>
        </kendo-pdf-export>
      </div>

      <div #pdfExportData *ngIf="reportData.reportFormatId == 0">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '300px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-custom-project-report
            [reportData]="reportData"
          ></piqet-angular-custom-project-report>
          <ng-template kendoPDFTemplate let-pageNum="pageNum">
            <div class="page-template">
              <div class="footer">
                <div class="pdfPagePosition">{{ pageNum }}</div>
              </div>
            </div>
          </ng-template>
        </kendo-pdf-export>
      </div>

      <!-- compact report -->
      <div *ngIf="reportData.reportFormatId == 4">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '0px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-compact-detail-report
            [reportData]="reportData"
          ></piqet-angular-compact-detail-report>
        </kendo-pdf-export>
      </div>

      <!-- product waste report -->
      <div *ngIf="reportData.reportFormatId == 6" class="main-slide-report">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '0px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-product-waste-report
            [reportData]="reportData"
            (checkContent)="exportPDF($event)"
          ></piqet-angular-product-waste-report>
        </kendo-pdf-export>
      </div>

      <!-- carbon footprint report -->
      <div *ngIf="reportData.reportFormatId == 8" class="main-slide-report">
        <kendo-pdf-export
          #pdf
          [paperSize]="'A4'"
          forcePageBreak=".page-break"
          [landscape]="false"
          [repeatHeaders]="true"
          [margin]="{
            top: '0px',
            right: '1cm',
            bottom: '3cm',
            left: '1cm'
          }"
          [scale]="0.6"
        >
          <piqet-angular-carbon-footprint-report
            [reportData]="reportData"
            (checkContent)="exportPDF($event)"
          ></piqet-angular-carbon-footprint-report>
        </kendo-pdf-export>
      </div>
    </ng-container>
  </div>
</div>
